import React, { useEffect, useState } from 'react';
import { Dropdown, Menu, Button, Empty, List, Row, Col, Progress, Flex, Space } from 'antd';
import { DownloadOutlined, PauseCircleOutlined, PlayCircleOutlined } from '@ant-design/icons';
import { useDownloadManager } from '../../contexts/DownloadManagerContext';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const DownloadList = () => {

    const  selectProductId  = useSelector((state) => state.selectProductId.selectProductId)
    const { t } = useTranslation();
    const { downloadList, DownloadStates, handleDownload } = useDownloadManager();


    


    const menu = downloadList.length ?
        downloadList.map((download, index) => {
            return {
                key: index,
                label: (
                    <List
                        itemLayout="horizontal" className='notification-items'>
                        <List.Item>
                            <Row style={{ width: "100%" }}>
                                <Col xs={24} sm={24} md={24} lg={24}>
                                    {download.title}

                                </Col>
                                <Col xs={24} sm={24} md={24} lg={24} >
                                    {download.name}
                                    <Flex justify="space-between">
                                    <Progress percent={download.progress} status="active" />
                                        <Space>
                                            {download.downloadStatus === DownloadStates.Downloading ? (
                                                <PauseCircleOutlined className='pause-resume' onClick={(e) => { e.stopPropagation(); handleDownload(download); }} />
                                            ) : (
                                                <PlayCircleOutlined className='pause-resume' onClick={(e) => { e.stopPropagation(); handleDownload(download); }} />
                                            )}
                                        </Space>
                                    </Flex>
                                </Col>
                            </Row>
                        </List.Item>
                    </List>
                ),
            };
        }) : [
            {
                key: "empty",
                label: (<Empty
                    image="/assets/images/empty.svg"
                    imageStyle={{
                        height: 90,
                    }}
                    description={
                        <span>
                            {t("download.empty")}
                        </span>
                    } />)
            }
        ]


    return (
        <Dropdown
            menu={{ items: menu }}
            placement="bottom"
            arrow={{
                pointAtCenter: true,
            }}
            overlayClassName='notifications'

        >
            <Button shape="circle" icon={<DownloadOutlined />} size="default" />
        </Dropdown>
    );
};

export default DownloadList;
